import React, { useState } from "react";
import Modal from "react-responsive-modal";
import img1 from "../../assets/newImages/Group 1399.png";
import img3 from "../../assets/newImages/Group 1403.png";
import img2 from "../../assets/newImages/Illustration.png";
import { FaStar } from "react-icons/fa";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import GoogleAuthentication from "../../components/SocialAuthentication/GoogleSocialAuth";
import FacebookAuthentication from "../../components/SocialAuthentication/FacebookSocialAuth";
import Input from "../../components/Input/InputComponent";
import { Link, useHistory } from "react-router-dom";
import Button from "../EmptyButton";
import { apiRequest, getApiKey, setKey, setUser } from "../../helpers";
import { GetUserInfo } from "../../services";
import { createErrorAlert } from "../../redux/actions";
import { useDispatch } from "react-redux";



const LoginModal = ({
  role,
  open,
  setLoginModal,
  onClose,
  focusTrapped,
  blockScroll,
  signup,
  closeOnOverlayClick,
  labelledBy,
  describedBy,
  center,
  style,
  classNames,
  redirectAfterLogin,
  onAuthenticated,
  showCloseIcon,
}) => {
    const [showPassword, setShowPassword] = useState(false);
  const validateSchema = Yup.object({
    password: Yup.string().required("Password is required"),
    email: Yup.string().email("Invalid email").required("Email is required"),
  });

  const history = useHistory()
  const dispatch = useDispatch()

  const userLogin = async (body) => {
    await apiRequest({
      method: "post",
      url: `accounts/dj-rest-auth/login/`,
      data: body,
    }).then(async (res) => {
      setKey(res.data.access_token);
      setLoginModal(false);
      setUser(JSON.stringify(res.data.user));
      if (getApiKey()) {
        if (onAuthenticated) {
          // dj-rest-auth's login response uses `pk`, not `id` — fetch the full
          // profile (same one the rest of the app reads from sessionStorage) instead.
          const userData = await GetUserInfo();
          setUser(JSON.stringify(userData));
          onAuthenticated(userData);
        } else if (redirectAfterLogin) {
          const userData = await GetUserInfo();
          setUser(JSON.stringify(userData));
          const separator = redirectAfterLogin.includes("?") ? "&" : "?";
          history.push(`${redirectAfterLogin}${separator}user_id=${userData.id}`);
        } else {
          window.location.reload();
        }
      }
    }).catch((err) => {
      let errorResponse
        for (const key in err.response.data) {
          if (err.response.data.hasOwnProperty(key) && Array.isArray(err.response.data[key]) && err.response.data[key].length > 0) {
            errorResponse = err.response.data[key][0]
          }
        }
      dispatch(createErrorAlert(400, '', errorResponse, 400))
    });
  };

  const login = (values) => {
    userLogin(values);
  };

  const forgetPass = () => {
    setLoginModal(false);
    history.push("/forget-password");
  };

  return (
    <Modal
      role={role}
      open={open}
      onClose={onClose}
      focusTrapped={focusTrapped}
      blockScroll={blockScroll}
      closeOnOverlayClick={closeOnOverlayClick}
      showCloseIcon={showCloseIcon !== false}
      aria-labelledby={labelledBy}
      aria-describedby={describedBy}
      center={center}
      styles={{style}}
      classNames={classNames}
    >
      <div className="flex gap-4">
        <div className="w-full hidden md:block">
          <p className="text-body-large  font-bold text-left md:text-h3 xl:text-36  mr-1">
            Join the movement of{" "}
            <span className="text-yellowish">
              26K savvy StudyCrowd.AI members
            </span>{" "}
            already empowered - and you're next
          </p>

          <p className=" text-body-small text-left pt-6 md:text-h5 xl:text-36 or-2">
            Discover the secret to success as you become part of our growing
            community.
          </p>
          <p className="text-body-small text-left pt-6 md:text-h5 xl:text-36 or-2">
            Find simple and concise study resources created by top graduates who
            took the same courses as you at US and UK universities
          </p>
          <div className="flex justify-around mt-10 items-center flex-col lg:flex-row">
            {/* <div className=" text-center">
                  <div className="w-116 h-100">
                    <img src={img1} className="m-auto mt-3 w-full h-full" />
                  </div>
                  <p className="  fw-bold text-42 text-yellowish ">35+</p>
                  <p>
                    Study Modules
                    <br />
                    All main areas of English law
                  </p>
                </div> */}
            <div className=" text-center">
              <div className="w-100 h-100">
                <img src={img2} className="m-auto mt-3 w-full h-full" />
              </div>
              <p className="fw-bold text-42  text-yellowish">50K+</p>
              <p>
                Active Users
                <br />
                in 2025
              </p>
            </div>
            <div className=" text-center">
              <div className="w-100 h-100">
                <img src={img3} className="m-auto mt-3 w-full h-full" />
              </div>
              <p className="fw-bold text-42  text-yellowish">2000+</p>
              <p className="h-51">
                Tutoring Hours and Career
                <br />
                Mentoring Hours <br />
                Delivered
              </p>
            </div>
          </div>
          <div
            className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-16"
            style={{ borderColor: "#f7f7f7" }}
          >
            <a
              href="https://www.reviews.co.uk/company-reviews/store/www.simplestudying.com"
              target="_blank"
              rel="noopener noreferrer"
              style={{ borderColor: "#f7f7f7" }}
              className="flex items-center justify-center space-x-3 p-4 bg-white rounded-lg border border hover:bg-white transition-colors cursor-pointer"
            >
              <FaStar className="w-6 h-6 text-primary" />
              <div className="text-left">
                <div className="font-bold text-foreground">4.6/5</div>
                <div className="text-sm text-muted-foreground">
                  Rating on Reviews.io
                </div>
              </div>
            </a>

            <a
              href="https://g.co/kgs/94X3PU6"
              target="_blank"
              rel="noopener noreferrer"
              style={{ borderColor: "#f7f7f7" }}
              className="flex items-center justify-center space-x-3 p-4 bg-white rounded-lg border border-white hover:bg-white transition-colors cursor-pointer"
            >
              <FaStar className="w-6 h-6 text-primary" />
              <div className="text-left">
                <div className="font-bold text-foreground">4.9/5</div>
                <div className="text-sm text-muted-foreground">
                  Rating on Google
                </div>
              </div>
            </a>
          </div>
          <div
            className="grid grid-cols-1 md:grid-cols-1 font-bold text-center gap-6 mt-16"
            style={{ borderColor: "#f7f7f7" }}
          >
            <p className="text-sm text-muted-foreground">
              Free to join • No credit card required • Instant access
            </p>
          </div>
        </div>
        <div className="w-full">
          <Formik
            initialValues={{
              password: "",
              email: "",
            }}
            validationSchema={validateSchema}
            onSubmit={(values) => login(values)}
          >
            {({ isValid, handleSubmit, values }) => (
              <Form
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleSubmit();
                  }
                }}
              >
                  <div className="loginInputMain flex flex-col text-darkest items-center">
                    <p className="loginHeadText text-darkest font-bold text-body-large mb-10 md:text-h3 xl:text-36 text-center">
                      Sign in to{" "}
                      <span className="text-yellowish">StudyCrowd.AI</span>
                    </p>

                    <div className="w-full mb-3 custom2::mb-9 ">
                      <GoogleAuthentication redirectAfterLogin={redirectAfterLogin} onAuthenticated={onAuthenticated} />

                      <p className="mb-8 mt-16">Email</p>
                      <Field
                        name="email"
                        as={Input}
                        autoComplete="off"
                        placeholder="Enter your email"
                        type="text"
                      />
                    </div>
                    <div className="w-full  mb-3 custom2:mb-9">
                      <p className="mb-8 ">Password</p>
                      <Field
                        name="password"
                        as={Input}
                        placeholder="Enter your password"
                        type={showPassword ? "text" : "password"}
                        setShowPassword={setShowPassword}
                        showPassword={showPassword}
                        inputType="password"
                        autoComplete="off"
                      />
                    </div>
                    <Link
                      className="mb-8 forgetText align-center"
                      onClick={forgetPass}
                    >
                      Forget Password?
                    </Link>
                  </div>
                  <div className="pt-4 flex justify-center mb-10">
                    <div className="w-full h:34 md:h-42 lg:h-51">
                      <Button
                        onClick={handleSubmit}
                        type="submit"
                        text="Log in"
                        filled
                        className="buttonClass"
                        disabled={
                          values.email === "" ||
                          values.password === "" ||
                          !isValid
                        }
                        loading={false}
                      />
                    </div>
                  </div>
              </Form>
            )}
          </Formik>
          <p className="loginBottomText font-normal text-darkest font-body-large text-center">
            You don't have an account yet?{" "}
            <a
              className="font-bold text-primary cursor-pointer"
              onClick={() => {
                signup(true);
                setLoginModal(false);
              }}
            >
              {"  "}Sign up
            </a>
          </p>
        </div>
      </div>
    </Modal>
  );
};

export default LoginModal;
